function getPriorityLevel(index: number) {
  const priorityMap: Record<number, { text: string }> = {
    0: {
      text: "Main",
    },
    1: {
      text: "Fallback",
    },
  };

  const priorityLevel = priorityMap[index];
  if (!priorityLevel) {
    return {
      text: `P${index}`,
    };
  }

  return priorityLevel;
}

export { getPriorityLevel };
